import DropDownList from "@/components/Dropdown"
import { ListStatus } from "@/constants/default"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"

export interface TransactionTypeFieldForm {
    code: string
    name: string
    status: boolean
    description: string
}

export default function Information() {
    const {t} = useTranslation()
    const listStatus = ListStatus();
    const {register, formState: { errors }, control} = useFormContext<TransactionTypeFieldForm>()

    return (
        <>
            <div className="mb-3">
                <label className="mb-1 block text-black dark:text-white">
                    {t("form.name")}
                </label>
                <input
                    type="text"
                    placeholder={t("placeholder.name")}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-1.5 px-2 outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:text-white dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                    {...register("name", {required: t("validation.required")})}
                />
                { errors.name && <p className="mt-1 text-rose-600">{errors.name.message}</p>}
            </div>
            <div className="mb-3">
                <label className="mb-1 block dark:text-white">
                    {t("form.status")}
                </label>
                <Controller
                    name="status"
                    control={control}
                    defaultValue={listStatus[1].value}
                    render={({field: {onChange, value}}) => <DropDownList selected={value} setSelected={onChange} list={listStatus} />}
                />
            </div>   
        </>
    )
}